let questions = Array.from(document.querySelectorAll(".question"));
questions.forEach(
  (button) => {
    button.addEventListener("click", () => {
      let panel = button.nextElementSibling;
      if (panel.style.maxHeight) {
        button.classList.remove("questionActive");
        panel.style.maxHeight = null;
        panel.style.padding = "0 1em";
        // panel.style.border = "0px solid #181818";
      } else {
        button.classList.add("questionActive");
        panel.style.maxHeight = panel.scrollHeight + "px";
        panel.style.padding = "1em";
        // panel.style.border = "2px solid #181818";
      }
    });
  }
);